import React, { useState } from 'react';

export default function PanelTitle(props) {
    return (
        <h3 className="panel-title">{ props.children }</h3>
    );
}